// @mui
import { Card, CardContent, Typography } from '@mui/material';

export default function GuideNewJobPostCard({ hasJobPost }) {
  return (
    <Card
      variant="outlined"
      sx={{
        minHeight: 120,
        borderRadius: 2,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        boxShadow: 'none',
        borderColor: "#919EAB52",
      }}
    >
      <CardContent sx={{ textAlign: "center", color: "text.secondary" }}>
        <Typography variant="subtitle2">공고가 없습니다.</Typography>
        {hasJobPost ? (
          <Typography variant="subtitle2">필터 조건을 변경해보세요.</Typography>
        ): (
          <Typography variant="subtitle2">새로운 공고를 작성해보세요.</Typography>
        )}
      </CardContent>
    </Card>
  );
};
